export default __webpack_public_path__ + "static/trends-light-546444af29e329216556e7f14590fb39.png";